import { HTMLAttributes } from 'react';

interface InfoTableHelperProps extends HTMLAttributes<HTMLDivElement> {
	title: string;
	subTitle?: string;
}

export const InfoTableHelper = ({
	title,
	subTitle,
	className,
	...props
}: InfoTableHelperProps) => (
	<div className={`w-full ${className}`} {...props}>
		<p>{title}</p>
		{subTitle && (
			<p className='text-sm text-gray-400 font-orator'>{subTitle}</p>
		)}
	</div>
);
